module.exports = __webpack_public_path__ + "img/Hero Image.3ee30701.jpeg";